import React from 'react';
import {
  Pressable,
  StyleSheet,
  Text,
  useWindowDimensions,
  View,
} from 'react-native';

type Props = {
  title?: string;
  body?: string;
  buttons?: {
    text: string;
    action: () => void;
  }[];
  align?: string;
  dismiss?: () => void;
};

export default function Popup({
  title,
  body,
  buttons,
  align = 'float',
  dismiss,
}: Props) {
  const { width } = useWindowDimensions();
  const styles = style(align, width);
  const onPress = (button) => {
    const result = button.action();
    if (result && result.then && dismiss) {
      result.then(dismiss);
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {title && <Text style={styles.title}>{title}</Text>}
        {body && <Text style={styles.body}>{body}</Text>}
        {buttons && buttons.length && (
          <View style={styles.buttonContainer}>
            {buttons.map((button) => (
              <Pressable key={button.text} onPress={() => onPress(button)}>
                <Text style={styles.button}>{button.text}</Text>
              </Pressable>
            ))}
          </View>
        )}
      </View>
    </View>
  );
}

const style = (align: string, width: number) => {
  let containerPosition: object = {
    position: 'absolute',
  };

  if (align === 'sticky') {
    containerPosition = {
      position: 'sticky',
      bottom: 0,
      left: 0,
    };
  } else if (align === 'fixed') {
    containerPosition = {
      position: 'fixed',
      bottom: 0,
      left: 0,
    };
  }

  return StyleSheet.create({
    // @ts-ignore
    container: {
      ...containerPosition,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, .4)',
      zIndex: 9999,
    },
    content: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: width > 900 ? '50%' : '80%',
      transform: 'translateX(-50%) translateY(-50%)',
      shadowRadius: 5,
      shadowOpacity: 0.1,
      backgroundColor: '#fff',
      padding: 20,
      borderRadius: 10,
    },
    title: {
      fontSize: 26,
      fontWeight: 'bold',
    },
    body: {
      fontSize: 18,
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 10,
      justifyContent: 'flex-end',
    },
    button: {
      fontSize: 16,
      fontWeight: 'bold',
      marginLeft: 10,
    },
  });
};
